import React, { useState } from 'react';
import { Treinamentos } from './Treinamentos';
import { Trilhas }      from './Trilhas';

const ABAS = [
  { id: 'treinamentos', label: 'Treinamentos', emoji: '🎓' },
  { id: 'trilhas',      label: 'Trilhas',      emoji: '🎯' },
];

export const Ensino = ({
  // Treinamentos
  usuarioAtual, isAdmin, usuarios,
  agendamentos, setAgendamentos,
  dadosTr, setDadosTr,
  // Trilhas
  trilhas, setTrilhas,
}) => {
  const [aba, setAba] = useState('treinamentos');

  return (
    <div style={s.container}>
      <div style={s.header}>
        <h2 style={s.titulo}>Ensino</h2>
      </div>

      <div style={s.abas}>
        {ABAS.map(a => (
          <button
            key={a.id}
            style={{ ...s.aba, ...(aba === a.id ? s.abaAtiva : {}) }}
            onClick={() => setAba(a.id)}
          >
            {a.emoji} {a.label}
          </button>
        ))}
      </div>

      <div style={s.conteudo}>
        {aba === 'treinamentos' && (
          <Treinamentos
            usuarioAtual={usuarioAtual}
            isAdmin={isAdmin}
            usuarios={usuarios}
            agendamentos={agendamentos}
            setAgendamentos={setAgendamentos}
            dadosTr={dadosTr}
            setDadosTr={setDadosTr}
          />
        )}
        {aba === 'trilhas' && (
          <Trilhas
            trilhas={trilhas}
            setTrilhas={setTrilhas}
            usuarioAtual={usuarioAtual}
            isAdmin={isAdmin}
            usuarios={usuarios}
            turmas={dadosTr?.turmas || []}
            cursos={dadosTr?.cursos || []}
          />
        )}
      </div>
    </div>
  );
};

const s = {
  container: { display: 'flex', flexDirection: 'column', gap: '1.25rem' },
  header:    { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  titulo:    { fontSize: '1.8rem', fontWeight: 700, color: '#1c1530', margin: 0 },
  abas:      { display: 'flex', gap: '0.5rem', borderBottom: '2px solid #eeeaf5', paddingBottom: '0.75rem', flexWrap: 'wrap' },
  aba: {
    background: 'transparent',
    border: '1px solid #e5e0ef',
    borderRadius: 20,
    color: '#5f5874',
    padding: '8px 20px',
    fontSize: 13,
    fontWeight: 500,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  abaAtiva: {
    background: '#7c3aed',
    border: '1px solid #7c3aed',
    color: 'white',
    fontWeight: 600,
  },
  conteudo: {},
};
